function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgQuittingSmoking = function SvgQuittingSmoking(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeLinecap: "square",
    d: "M14.717 9.698H2.708v2.288h12.009zM16 9.698v2.286M17.291 9.698v2.286M5.59 6.465l9.127 9.118M16 8.901s-.152-.786-.78-.864c-.63-.079-1.573-.032-2.123-.429s-.354-1.418-.354-1.418M17.29 8.901s.052-1.218-.695-1.65c-.747-.433-1.533-.887-1.69-1.446s0-1.388 0-1.388"
  }));
};
export default SvgQuittingSmoking;